import { default as Spacing } from './Spacing';

export default Spacing;
